module.exports = __webpack_public_path__ + "static/media/RBLBANK_F1.941811ea.txt";